module.exports = __webpack_public_path__ + "img/image24.7724183a.jpg";